<section
  class="datetime-range flex flex-nograp gap-y-2.5 w-[100%]"
  [ngClass]="isRow ? 'flex-row' : 'flex-col'"
>
  <div class="datetime-range__start min-w-[50%]" [ngClass]="{ 'mr-4': isRow }">
    <phoenix-datetime-input
      type="datetime-local"
      [inputId]="idPrefix + '-start'"
      [placeholder]="startDatePlaceholder"
      [control]="startDateControl"
      [maxDate]="today"
    ></phoenix-datetime-input>
  </div>
  <div class="datetime-range__end min-w-[50%]">
    <phoenix-datetime-input
      type="datetime-local"
      [inputId]="idPrefix + '-end'"
      [placeholder]="endDatePlaceholder"
      [control]="endDateControl"
      [minDate]="start"
    ></phoenix-datetime-input>
  </div>
</section>
